export default {
  methods: {
    refreshWidget() {
      this.$emit('refresh', this.queue)
    },
  },
}
